import { BehaviorSubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class DrawerService {
  sidenavCollapsed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    !!localStorage.getItem('collapsedSidebar')
  );
  sidenavCollapsing$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  sidebarNavDrawer?: MatSidenav;

  setSidebarNavDrawer(drawer: MatSidenav) {
    this.sidebarNavDrawer = drawer;
  }

  toggleSidenav(): void {
    this.sidenavCollapsing$.next(true);
    this.sidenavCollapsed$.next(!this.sidenavCollapsed$.getValue());

    if (this.sidenavCollapsed$.getValue()) {
      localStorage.setItem('collapsedSidebar', 'true');
    } else {
      localStorage.removeItem('collapsedSidebar');
    }

    this.sidebarNavDrawer?.toggle();
    this.sidebarNavDrawer?.toggle();

    const transition = setInterval(() => {
      const content = document.getElementsByTagName(
        'mat-sidenav-content'
      )[0] as HTMLElement;
      content.click();
    }, 50);

    setTimeout(() => {
      clearInterval(transition);
      this.sidenavCollapsing$.next(false);
    }, 350);
  }
}
